/* eslint-disable no-unused-vars */
import { RefObject, useRef } from 'react'
import { useGSAP } from '@gsap/react'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'

import { useLoaderStore } from '@/store/loader'
import { useRouterStore } from '@/store/router'

import { Animation } from '@/types'

type MotionProps = {
  children: (ref: RefObject<HTMLDivElement>) => React.ReactNode
  animation: (props: Animation<HTMLElement>) => (() => void) | void // gsap.core.Timeline
  nodeRef?: RefObject<HTMLElement>
  revertOnUpdate?: boolean
}

const Motion = ({
  nodeRef,
  children,
  animation,
  revertOnUpdate = true
}: MotionProps) => {
  const root = useRef<HTMLDivElement>(null!)
  const heroLoaded = useLoaderStore((state) => state.heroLoaded)
  const currentRoute = useRouterStore((state) => state.currentRoute)
  const previousRoute = useRouterStore((state) => state.previousRoute)

  useGSAP(
    (context) => {
      if (!heroLoaded || !root.current) return

      const isInViewport = ScrollTrigger.isInViewport(root.current)
      const isLanding = previousRoute === undefined

      const revert = animation({
        node: root.current,
        mobile: false,
        reverse: false,
        nodeRef,
        context,
        delay: isLanding && isInViewport ? 0.3 : 0
      })

      const refreshRaf = requestAnimationFrame(() => {
        ScrollTrigger.refresh()
        ScrollTrigger.update()
      })

      return () => {
        cancelAnimationFrame(refreshRaf)

        if (revert) {
          revert()
        }
      }
    },
    {
      dependencies: [heroLoaded, currentRoute, previousRoute],
      scope: nodeRef || root,
      revertOnUpdate
    }
  )

  return children(root)
}

export default Motion
